import {
  BooleanInput,
  Create,
  Edit,
  NumberInput,
  SelectInput,
  SimpleForm,
  TextInput,
} from 'react-admin';

import { TemplateSectionsPanel } from './TemplateSectionsPanel';

const SITE_TYPE_CHOICES = [
  { id: 'static', name: 'Static site' },
  { id: 'menu', name: 'Menu site' },
  { id: 'digital_catalog', name: 'Digital catalog' },
  { id: 'custom_html', name: 'HTML page (custom variables)' },
];

const TemplateFormFields = () => (
  <>
    <TextInput source="name" fullWidth validate={(value) => (!value ? 'Name is required' : undefined)} />
    <TextInput source="slug" fullWidth validate={(value) => (!value ? 'Slug is required' : undefined)} />
    <TextInput source="description" fullWidth multiline rows={2} />
    <SelectInput source="site_type" label="Site type" choices={SITE_TYPE_CHOICES} />
    <BooleanInput source="is_active" label="Active" defaultValue />
    <NumberInput source="version" label="Version" />
    <TextInput
      source="default_theme"
      label="Default Theme (JSON)"
      fullWidth
      multiline
      rows={4}
      format={(value) => (typeof value === 'object' ? JSON.stringify(value, null, 2) : value)}
      parse={(value) => {
        if (!value) return {};
        try {
          return JSON.parse(value as string);
        } catch {
          return value;
        }
      }}
    />
    <TextInput
      source="layout_config"
      label="Layout Config (JSON)"
      fullWidth
      multiline
      rows={4}
      format={(value) => (typeof value === 'object' ? JSON.stringify(value, null, 2) : value)}
      parse={(value) => {
        if (!value) return {};
        try {
          return JSON.parse(value as string);
        } catch {
          return value;
        }
      }}
    />
  </>
);

export function TemplateEdit() {
  return (
    <Edit aside={<TemplateSectionsPanel />}>
      <SimpleForm>
        <TemplateFormFields />
      </SimpleForm>
    </Edit>
  );
}

export function TemplateCreate() {
  return (
    <Create redirect="list">
      <SimpleForm defaultValues={{ default_theme: {}, layout_config: {}, is_active: true, version: 1 }}>
        <TextInput source="name" fullWidth validate={(value) => (!value ? 'Name is required' : undefined)} />
        <TextInput source="slug" fullWidth validate={(value) => (!value ? 'Slug is required' : undefined)} />
        <TextInput source="description" fullWidth multiline rows={2} />
        <SelectInput source="site_type" label="Site type" choices={SITE_TYPE_CHOICES} />
        <TextInput
          source="default_theme"
          label="Default Theme (JSON)"
          fullWidth
          multiline
          rows={4}
          format={(value) => (typeof value === 'object' ? JSON.stringify(value, null, 2) : value ?? '{}')}
          parse={(value) => {
            if (!value) return {};
            try {
              return JSON.parse(value as string);
            } catch {
              return {};
            }
          }}
        />
        <TextInput
          source="layout_config"
          label="Layout Config (JSON)"
          fullWidth
          multiline
          rows={4}
          format={(value) => (typeof value === 'object' ? JSON.stringify(value, null, 2) : value ?? '{}')}
          parse={(value) => {
            if (!value) return {};
            try {
              return JSON.parse(value as string);
            } catch {
              return {};
            }
          }}
        />
      </SimpleForm>
    </Create>
  );
}
